import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NxButtonComponent } from '@aposin/ng-aquila/button';
import { NxCheckboxComponent } from '@aposin/ng-aquila/checkbox';
import { AlertService } from '@core/services/alert.service';
import { CommonService } from '@core/services/common.service';
import { DataService } from '@core/services/data.service';
import { InboxService } from '@core/services/inbox.service';
import { LoadingService } from '@core/services/loading.service';
import { UserService } from '@core/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { AkMessage } from '@shared/models/ak-message';
import { MailItem, MailItemList } from '@shared/models/mail-item';
import { User } from '@shared/models/user';
import { ClaimsTablePaginationDirections } from 'az-customer-portal-ui';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-inbox',
    templateUrl: './inbox.component.html',
    styleUrls: ['./inbox.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InboxComponent {
    public loggedUser: User = new User();

    public navList = [];
    public pagedList: MailItem[] = [];
    public mailList: MailItemList;
    public mailItemDetails: MailItem[] = [];

    public isDrawerOpen = true;
    public isSent = false;
    public activePage = 1;
    public perPage = 5;
    public maxPage = 0;
    readonly paginationDirections: typeof ClaimsTablePaginationDirections = ClaimsTablePaginationDirections;

    public detailItem = false;
    public showDocuments = true;

    private thresholdMultiplicator = 2;
    @ViewChild('deleteBtn') deleteBtn: NxButtonComponent;
    @ViewChild('selectAllCheckbox') selectAllCheckbox: NxCheckboxComponent;
    
    //public isInReply = true;
    public selectedComponent = 'inbox';
    public isInReply = false;
    public textData = {
        "reply": "",
        "send": "",
        "download": "",
        "textAreaPlaceHolder": ""
    };

    // textarea handler
    private message = null;
    private savedMessage = null;
    private deleteBtnClicked = false;
    public isDeletedComponent = false;
    public isSentComponent = false;
    public isInboxComponent = true;

    private checkedItems = {};
    public selectAllCheckboxChecked = false;

    constructor(
        private userService: UserService,
        private dataService: DataService,
        private inboxService: InboxService,
        private commonService: CommonService,
        private router: Router,
        private alertService: AlertService,
        private translateService: TranslateService,
        public loadingService: LoadingService,
    ) {

        if (this.dataService.inboxSelectedComponent) {
            this.changeRoute(null, this.dataService.inboxSelectedComponent);
            this.dataService.inboxSelectedComponent = null;
        }


        this.userService.getLoggedUser().subscribe(res => {
            this.loggedUser = res;
            this.getInboxList();
        });

        this.navList = this.dataService.emailUsNavList.filter(x => x.show == true);
        let currentTimeHour = new Date().getHours();
        let currentTimeMinute = new Date().getMinutes();
        if ((currentTimeHour > 22 && currentTimeMinute > 58) || (currentTimeHour < 6 && currentTimeMinute < 0)) {
            this.showDocuments = false;
        }
    }

    handleOpen($event): void {
        //this.isDrawerOpen = !this.isDrawerOpen;
    }

    getTranslatedTextData() {

        this.textData.reply = this.translateService.instant('inbox.email-us.message-preview.text-data.reply-to-message');
        // if (this.formBEValid) {
        //     this.textData.reply = this.translateService.instant('inbox.email-us.result.btnText');
        // }
        this.textData.download = this.translateService.instant('inbox.email-us.message-preview.text-data.download');
        this.textData.send = this.translateService.instant('inbox.email-us.message-preview.text-data.send');
        this.textData.textAreaPlaceHolder = this.translateService.instant('inbox.email-us.message-preview.text-data.textAreaPlaceHolder');

        return this.textData;
    }

    private getInboxList() {
        this.inboxService.getInboxList(this.selectedComponent).subscribe(mailList => {
            this.mailList = mailList;

            this.dataService.notOpenedEmails.next(mailList.unreadMessagesCount);
            this.reloadPagedList();
            this.goToPage(1);
        });
    }

    // there is only one item
    changeRoute($event, component?: string) {
        this.isInReply = false;
        if (component != this.selectedComponent) {
            this.selectedComponent = component;
            this.getInboxList();
        }

        this.isDeletedComponent = component == 'deleted';
        this.isSentComponent = component == 'sent';
        this.isInboxComponent = component == 'inbox';

        if (this.detailItem) {
            this.showList();
        } else {
            return;
        }
    }

    changeDetection($event) {
        this.checkedItems[$event.id] = !this.checkedItems[$event.id];

        this.deleteBtn.disabled = true;
        if (Object.values(this.checkedItems).some(x => x === true)) {
            this.deleteBtn.disabled = false;
        }
    }

    showContent(mailItem: MailItem, $event: PointerEvent) {
        this.isSent = false;
        const trgt = $event.target;
        if (trgt instanceof HTMLDivElement && trgt.classList.contains('cpc-checkbox_indicator')) {
            return;
        }

        if (mailItem.unread === true) {
            this.inboxService.postUpdateAkInbox(mailItem).subscribe();
            this.dataService.notOpenedEmails.next(--this.mailList.unreadMessagesCount);
        }

        this.detailItem = !this.detailItem;
        mailItem.variant = 'read';
        this.loadMailItemDetails(mailItem);
    }

    private loadMailItemDetails(mailItem: MailItem) {
        mailItem.threadId ? this.inboxService.getMessagesInThread(mailItem.threadId).subscribe(result => {
            this.mailItemDetails = result;
        }) : this.mailItemDetails = [mailItem];
    }

    /**
     * Show textarea
     */
    clickReply($event) {
        this.isInReply = true;
    }

    showList() {
        this.checkedItems = {};
        this.selectAllCheckboxChecked = false;
        this.pagedList.forEach(mailItem => {
            mailItem.checkbox.checked = false;
        });
        this.isInReply = false;
        this.detailItem = !this.detailItem;
    }

    clickDownload(upItemId: string): void {
        if (upItemId != '' && upItemId != undefined) {
            window.open(this.commonService.downloadDocumentUrl + upItemId, '_blank');
        }
    }

    get lastItemDetail(): MailItem {
        return this.mailItemDetails[this.mailItemDetails.length - 1];
    }

    get firstItemDetail(): MailItem {
        return this.mailItemDetails[0];
    }

    /**
     * Pagination
     */
    prevPage(): void {
        this.activePage--;
        this.reloadPagedList();
    }

    nextPage(): void {
        this.activePage++;
        this.reloadPagedList();
    }

    reloadPagedList(): void {
        this.maxPage = Math.ceil(this.mailList.pagination.maxItems / this.perPage) - 1;
        const start = (this.activePage - 1) * this.perPage;

        if (start * (this.mailList.pagination.page + 1) > this.mailList.pagination.wsItemsPerPage * (this.mailList.pagination.page + 1)) {
            this.inboxService.getInboxList(this.selectedComponent, this.mailList.pagination.page + 1).subscribe(mailList => {
                this.mailList.list.concat(mailList.list);
            });

            this.pagedList = this.mailList.list.slice(start, start + this.perPage);
        } else {
            this.pagedList = this.mailList.list.slice(start, start + this.perPage);
        }
    }

    goToPage(n: number): void {
        this.activePage = n;
        this.reloadPagedList();
    }

    handleChangeItemsPerPage($event): void {
        if ((Math.ceil(this.mailList.pagination.maxItems / $event) - 1) < this.maxPage) {
            this.maxPage = Math.ceil(this.mailList.pagination.maxItems / $event);
            this.goToPage(1);
        }

        this.perPage = $event;
        this.reloadPagedList();
    }

    handleChangePage($event): void {
        if ($event === this.paginationDirections.Next && this.activePage <= this.maxPage) {
            this.activePage++;
        }
        if ($event === this.paginationDirections.Prev && this.activePage > 1) {
            this.activePage--;
        }
        this.reloadPagedList();
    }

    /**
     * Clear textarea
     */
    clickDelete() {
        this.deleteBtnClicked = true;
        if (this.message == null) {
            this.message = document.getElementById('message-preview-text-area');
        }

        this.message.value = "";
    }

    /**
   * Set textarea message
   */
    clickSend() {
        this.message = document.getElementById('message-preview-text-area');
    }

    /**
    * Submit
    */
    submit($event) {
        if (this.message.value.length < 10) {
            const options = {
                autoClose: true
            };
            this.alertService.warn(this.translateService.instant('inbox.email-us.message-preview.additional.min-text-length'), options);
            return false;
        }

        let akMessage = new AkMessage();

        akMessage.topicKey = this.lastItemDetail.policyNumber ? 'topic-reply-message-policy' : 'topic-reply-message-claim';
        akMessage.message = this.message.value;
        akMessage.policyNumber = this.lastItemDetail.policyNumber;
        akMessage.claimNumber = this.lastItemDetail.claimNumber;
        akMessage.dms2DocboxId = this.lastItemDetail.dms2DocboxId;
        akMessage.dms2docBrandId = this.lastItemDetail.dms2docBrandId;
        akMessage.dms2docCatId = this.lastItemDetail.dms2docCatId;
        akMessage.dms2docId = this.lastItemDetail.dms2docId;
        akMessage.mailSubj = this.lastItemDetail.title;
        akMessage.messageId = this.lastItemDetail.checkbox.id;
        akMessage.dms2Actnumber = this.lastItemDetail.dms2Actnumber;
        akMessage.dms2Secflag = this.lastItemDetail.dms2Secflag;

        this.inboxService.postCreateAkMessage(akMessage).subscribe(res => {
            this.isSent = true;
            //this.loadMailItemDetails(this.lastItemDetail);
        });

        return false;
    }

    deleteMessage() {
        this.deleteBtn.disabled = true;

        let deletedMessagesCount = 0;
        this.pagedList.forEach(mailItem => {
            if (mailItem.checkbox.checked) {
                deletedMessagesCount++;
            }
        });

        let deletedMessagesCountTmp = [];
        this.pagedList.forEach(mailItem => {
            !mailItem.checkbox.checked ? null : this.inboxService.postRemoveMessage(mailItem.checkbox.id)
                .subscribe(result => {
                    deletedMessagesCountTmp.push(true);
                    if (deletedMessagesCountTmp.length == deletedMessagesCount) {
                        this.translateService.get('inbox.email-us.notification.msg-deleted').subscribe(x => {
                            this.alertService.info(x);
                        });
                        this.getInboxList();
                        this.selectAllCheckbox.checked = false;
                    }
                });
        });
    }

    selectMessages() {
        this.selectAllCheckboxChecked = !this.selectAllCheckboxChecked;
        this.pagedList.forEach(mailItem => {
            this.changeDetection(mailItem);
            mailItem.checkbox.checked = this.selectAllCheckboxChecked;
        });
    }
}